// src/pages/Login/ForgotPassword.js
import AuthLayout from 'components/layout/AuthLayout'
import { inputClass, labelClass, linkClass, submitButtonClass, errorAlertClass, successAlertClass } from 'forms/Login/authStyles'
import { Field, Form, Formik } from 'formik'
import useFetch from 'hooks/useFetch'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'wouter'
import * as Yup from 'yup'

export default function ForgotPassword() {
  const { t, i18n } = useTranslation()
  const [, setLocation] = useLocation()
  const [requestState, sendRequest] = useFetch()
  const [sent, setSent] = useState(false)

  const validationSchema = Yup.object().shape({
    email: Yup.string().email(t('login.v_email_invalid')).required(t('login.v_email_required'))
  })

  const handleSubmit = async (values) => {
    const result = await sendRequest({
      url: 'auth/forgot-password',
      method: 'POST',
      body: { email: values.email, lang: (i18n.language || 'es').slice(0, 2) }
    })
    if (!result?.error) setSent(true)
  }

  return (
    <AuthLayout subtitle={t('password_reset.forgot_subtitle')}>
      {sent ? (
        <div className={successAlertClass} role="status">
          {t('password_reset.forgot_sent')}
        </div>
      ) : (
        <Formik initialValues={{ email: '' }} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {({ errors, touched }) => (
            <Form>
              <label htmlFor="email" className={labelClass(touched.email && errors.email)}>
                {t('login.email')}
              </label>
              <Field
                id="email"
                name="email"
                type="email"
                className={`${inputClass(touched.email && errors.email)} mt-2`}
                autoComplete="email"
                placeholder="example@example.com"
              />
              <p className={`mt-1 text-sm leading-none text-red-600 ${touched.email && errors.email ? 'visible' : 'invisible'}`}>
                {errors.email || ' '}
              </p>

              <div className="mt-5">
                <button type="submit" className={submitButtonClass} disabled={requestState.loading}>
                  {requestState.loading ? t('password_reset.sending') : t('password_reset.send_link')}
                </button>
              </div>

              {requestState.error && !requestState.loading && (
                <div className={`${errorAlertClass} mt-3`} role="alert">
                  {t('password_reset.generic_error')}
                </div>
              )}
            </Form>
          )}
        </Formik>
      )}

      <div className="mt-6 text-center">
        <a
          href="/login"
          onClick={(e) => { e.preventDefault(); setLocation('/login') }}
          className={linkClass}
        >
          {t('password_reset.back_to_login')}
        </a>
      </div>
    </AuthLayout>
  )
}
